import { customizeError } from '@chilecompra/react-kit'
import { WORK_REGISTER_CODES, REGISTRY_CODE_BY_KEY } from '../../config/settings/constant'
import { makeActionCreator } from '../../config/store/utils'
import { getMinvuRegistry, getMopRegistry } from '../../services/workRegister'
import { adapterMinvuResponse } from './WorkRegister.minvu-adapter'
import { adapterMopResponse } from './WorkRegister.mop-adapter'

export const LOAD_INITIAL_REGISTRIES = 'LOAD_INITIAL_REGISTRIES'
export const LOAD_INITIAL_REGISTRIES_ERROR = 'LOAD_INITIAL_REGISTRIES_ERROR'
export const LOAD_INITIAL_REGISTRIES_SUCCESS = 'LOAD_INITIAL_REGISTRIES_SUCCESS'
export const onLoadInitialRegistries = makeActionCreator(LOAD_INITIAL_REGISTRIES)
export const onLoadInitialRegistriesError = makeActionCreator(LOAD_INITIAL_REGISTRIES_ERROR, 'payload')
export const onLoadInitialRegistriesSuccess = makeActionCreator(LOAD_INITIAL_REGISTRIES_SUCCESS, 'payload')
export const onLoadInitialRegistriesThunk = payload => async dispatch => {
  const { dni = '' } = payload

  dispatch(onLoadInitialRegistries())

  try {
    const codes = [WORK_REGISTER_CODES.CONTRACTORS, WORK_REGISTER_CODES.CONSULTANTS]

    const minvuPromises = codes.map(registerCode => ({
      value: `${REGISTRY_CODE_BY_KEY[registerCode]}_minvu`,
      promise: getMinvuRegistry({
        dni,
        page: 1,
        registerCode
      })
    }))

    const mopPromises = codes.map(registerCode => ({
      value: `${REGISTRY_CODE_BY_KEY[registerCode]}_mop`,
      promise: getMopRegistry({
        dni,
        page: 1,
        registerCode
      })
    }))

    const promises = [...minvuPromises, ...mopPromises]

    const settledRegistries = await Promise.allSettled(
      promises.map(async ({ value, promise }) => {
        try {
          const response = await promise
          return {
            key: value,
            data: response?.data
          }
        } catch (error) {
          return {
            key: value,
            data: {
              data: {
                success: false
              },
              error
            }
          }
        }
      })
    )

    const registriesByKey = settledRegistries.reduce((accumulator, item) => {
      accumulator[item.value.key] = item.value.data

      return accumulator
    }, {})

    const contractorsMinvu = registriesByKey.contractors_minvu
    const consultantsMinvu = registriesByKey.consultants_minvu
    const contractorsMop = registriesByKey.contractors_mop
    const consultantsMop = registriesByKey.consultants_mop

    const allRejected = [contractorsMinvu, consultantsMinvu, contractorsMop, consultantsMop].every(
      item => item?.value?.data?.success === false
    )

    if (allRejected) {
      dispatch(
        onLoadInitialRegistriesError({
          error: customizeError({
            originalError: contractorsMinvu?.error?.originalError,
            code: contractorsMinvu?.error?.code,
            reason: contractorsMinvu?.error?.reason
          }).toObject()
        })
      )
      return
    }

    dispatch(
      onLoadInitialRegistriesSuccess({
        consultants: adapterMinvuResponse(consultantsMinvu?.payload),
        contractors: adapterMinvuResponse(contractorsMinvu?.payload),
        consultantsMop: adapterMopResponse(consultantsMop?.payload, WORK_REGISTER_CODES.CONSULTANTS),
        contractorsMop: adapterMopResponse(contractorsMop?.payload, WORK_REGISTER_CODES.CONTRACTORS)
      })
    )
  } catch (error) {
    console.error('onLoadInitialRegistriesThunk[error]', error)
    dispatch(
      onLoadInitialRegistriesError({
        error: customizeError({
          originalError: error?.originalError,
          code: error.code,
          reason: 'SOMETHING_WENT_WRONG_ERROR'
        }).toObject()
      })
    )
  }
}

export const GET_MINVU_REGISTRY = 'GET_MINVU_REGISTRY'
export const GET_MINVU_REGISTRY_ERROR = 'GET_MINVU_REGISTRY_ERROR'
export const GET_MINVU_REGISTRY_SUCCESS = 'GET_MINVU_REGISTRY_SUCCESS'
export const onGetMinvuRegistry = makeActionCreator(GET_MINVU_REGISTRY)
export const onGetMinvuRegistryError = makeActionCreator(GET_MINVU_REGISTRY_ERROR, 'payload')
export const onGetMinvuRegistrySuccess = makeActionCreator(GET_MINVU_REGISTRY_SUCCESS, 'payload')
export const onGetMinvuRegistryThunk = payload => async dispatch => {
  const { dni = '', page = 1, registerCode = '' } = payload

  dispatch(onGetMinvuRegistry({ registerCode }))

  try {
    const key = REGISTRY_CODE_BY_KEY[registerCode]

    if (!key) return

    const { data } = await getMinvuRegistry({
      dni,
      page,
      registerCode
    })

    dispatch(
      onGetMinvuRegistrySuccess({
        [key]: adapterMinvuResponse(data?.payload),
        registryCodeKey: key
      })
    )
  } catch (error) {
    dispatch(
      onGetMinvuRegistryError({
        error: customizeError({
          originalError: error?.originalError,
          code: error.code,
          reason: 'SOMETHING_WENT_WRONG_ERROR'
        }).toObject()
      })
    )
  }
}

export const GET_MOP_REGISTRY = 'GET_MOP_REGISTRY'
export const GET_MOP_REGISTRY_ERROR = 'GET_MOP_REGISTRY_ERROR'
export const GET_MOP_REGISTRY_SUCCESS = 'GET_MOP_REGISTRY_SUCCESS'
export const onGetMopRegistry = makeActionCreator(GET_MOP_REGISTRY, 'payload')
export const onGetMopRegistryError = makeActionCreator(GET_MOP_REGISTRY_ERROR, 'payload')
export const onGetMopRegistrySuccess = makeActionCreator(GET_MOP_REGISTRY_SUCCESS, 'payload')
export const onGetMopRegistryThunk = payload => async dispatch => {
  const { dni = '', page = 1, registerCode = '' } = payload

  dispatch(onGetMopRegistry({ registerCode }))

  try {
    const key = REGISTRY_CODE_BY_KEY[registerCode]

    if (!key) return

    const { data } = await getMopRegistry({
      dni,
      page,
      registerCode
    })

    dispatch(
      onGetMopRegistrySuccess({
        [key]: adapterMopResponse(data?.payload),
        registryCodeKey: key
      })
    )
  } catch (error) {
    dispatch(
      onGetMopRegistryError({
        error: customizeError({
          originalError: error?.originalError,
          code: error.code,
          reason: 'SOMETHING_WENT_WRONG_ERROR'
        }).toObject()
      })
    )
  }
}
